import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function Product() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title="Sản phẩm công ty" name="Product" />
        </Container>
      </div>
    </React.Fragment>
  );
}
